import React from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';
import Routes from 'react-static-routes';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';

class AppRoutesWrapper extends React.PureComponent {
  componentDidMount() {
    const {
      language,
      supportedLanguages,
      location: routerLocation,
    } = this.props;

    const localStorageLang = window.localStorage.getItem('setLang');
    const browserLang = navigator.language.split('-')[0];
    const nextLang = localStorageLang || browserLang;
    // change to KO from url
    if (!language) {
      window.localStorage.setItem('setLang', nextLang || 'en');
      this.props.i18n.changeLanguage(nextLang || 'en');
      if (!routerLocation.pathname.includes('/en')) {
        location.href = `/${nextLang || ''}`;
      } else {
        location.href = '/';
      }
      return;
    }

    // Detect language from localStorage and Browser
    if (
      language === 'en' &&
      nextLang !== 'en' &&
      nextLang !== 'ja' &&
      supportedLanguages.includes(nextLang)
    ) {
      const currentPath = `/en${routerLocation.pathname}`;
      const searchParams = window.location.search;
      const nextPath = currentPath.replace(`/${language}`, `/${nextLang}`);

      /* eslint-disable */
      // window.location
      location.href = nextPath + searchParams;
      /* eslint-enable */
    }

    this.props.i18n.changeLanguage(language);
  }

  render() {
    return <Routes />;
  }
}

AppRoutesWrapper.propTypes = {
  i18n: PropTypes.shape({
    changeLanguage: PropTypes.func,
  }),
  language: PropTypes.string,
};

export default withNamespaces()(withRouteData(withRouter(AppRoutesWrapper)));



// WEBPACK FOOTER //
// ../src/components/App/AppRoutesWrapper.jsx